import React, { useContext, useState, useEffect } from "react";
import Main from "./Main";
import { useTranslation } from "react-i18next";
import { CartContext } from "../Context/Context";
import NavButton from "./Button/NavButton";
import Project from "./Project";

export default function Projects() {
  const { t } = useTranslation();
  const ctx = useContext(CartContext);
  const [categories, setCategories] = useState("");
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    setProjects([]);
    t("project", { returnObjects: true }).map((project) => {
      if (categories === "Games") {
        if (project.id === 17 || project.id === 15) {
          return setProjects((prevState) => [...prevState, project]);
        }
      }
      if (project.technologies.indexOf(categories) >= 0) {
        return setProjects((prevState) => [...prevState, project]);
      }
    });
  }, [categories, ctx.language]);

  return (
    <>
      <Main />
      <section className="projects" id="projects">
        <NavButton setCategories={setCategories} categories={categories} />
        <article className="container">
          <div className="description-categorie">
            {categories === "" ? (
              t("projectDescription.allproject")
            ) : categories ? (
              <div>
                {t("projectDescription.category")} <b>{categories}</b>
              </div>
            ) : (
              "Error"
            )}
          </div>
          <div className="grid">
            {projects.map((project) => (
              <Project key={project.id} project={project} />
            ))}
          </div>
        </article>
      </section>
    </>
  );
}
